import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-flower-line text-xl text-primary-500"></i>
            </span>
            <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
              初音岛
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.includes(cat.slug)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}